import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';


import { MarkdownModule } from 'ngx-markdown';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';

import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

import { AttentionItemsSummaryComponent } from '../attention-items/attention-items-summary/attention-items-summary.component';
import { ActivityComponent } from '../dashboardv2/activity/activity.component';
import { DashboardAiActivationsComponent } from '../dashboardv2/dashboard-ai-activations/dashboard-ai-activations.component';
import { DashboardBillingComponent } from '../dashboardv2/dashboard-billing/dashboard-billing.component';
import { DashboardEmptyStateComponent } from '../dashboardv2/dashboard-empty-state/dashboard-empty-state.component';
import { DashboardEngineComponent } from '../dashboardv2/dashboard-engine/dashboard-engine.component';
import { DashboardInfoV2Component } from '../dashboardv2/dashboard-info-v2/dashboard-info-v2.component';
import { DashboardNumberComponent } from '../dashboardv2/dashboard-number/dashboard-number.component';
import { DashboardOpsReadinessComponent } from '../dashboardv2/dashboard-ops-readiness/dashboard-ops-readiness.component';
import { DashboardOtrLaborTrackingComponent } from '../dashboardv2/dashboard-otr-labor-tracking/dashboard-otr-labor-tracking.component';
import { DashboardOtrOpsReadinessComponent } from '../dashboardv2/dashboard-otr-ops-readiness/dashboard-otr-ops-readiness.component';
import { DashboardOtrSystemRevenueComponent } from '../dashboardv2/dashboard-otr-system-revenue/dashboard-otr-system-revenue.component';
import { DashboardRevenueComponent } from '../dashboardv2/dashboard-revenue/dashboard-revenue.component';
import { DashboardSalesLeaderboardComponent } from '../dashboardv2/dashboard-sales-leaderboard/dashboard-sales-leaderboard.component';
import { DashboardSelfImprovingAIComponent } from '../dashboardv2/dashboard-self-improving-ai/dashboard-self-improving-ai.component';
import { DashboardShellComponent } from '../dashboardv2/dashboard-shell/dashboard-shell.component';
import { DashboardSystemRevenueComponent } from '../dashboardv2/dashboard-system-revenue/dashboard-system-revenue.component';
import { DashboardTransactionsComponent } from '../dashboardv2/dashboard-transactions/dashboard-transactions.component';
import { Dashboardv2Component } from '../dashboardv2/dashboardv2.component';
import { DeltaComponent } from '../dashboardv2/delta/delta.component';
import { EngineJobComponent } from '../dashboardv2/engine-job/engine-job.component';
import { EnginePreviewComponent } from '../dashboardv2/engine-preview/engine-preview.component';
import { ErrorIconComponent } from '../dashboardv2/error-icon/error-icon.component';
import { EventSummaryComponent } from '../dashboardv2/event-summary/event-summary.component';
import { LogisticsComponent } from '../dashboardv2/logistics/logistics.component';
import { PipelineComponent } from '../dashboardv2/pipeline/pipeline.component';
import { RevenueComponent } from '../dashboardv2/revenue/revenue.component';
import { TransactionsActivityComponent } from '../dashboardv2/transactions-activity/transactions-activity.component';
import { FreyaCommonModule } from '../freya-common/freya-common.module';
import { OverviewChipComponent } from '../job/job-overview/overview-header/overview-chip/overview-chip.component';
import { SharedModule } from '../shared/shared.module';

import { ChangeComponent } from './change/change.component';

@NgModule({
  declarations: [
    Dashboardv2Component,
    DashboardShellComponent,
    DashboardRevenueComponent,
    DashboardEngineComponent,
    DashboardBillingComponent,
    DashboardAiActivationsComponent,
    DashboardSalesLeaderboardComponent,
    DashboardSystemRevenueComponent,
    DashboardTransactionsComponent,
    DashboardOtrSystemRevenueComponent,
    DashboardOtrLaborTrackingComponent,
    DashboardOpsReadinessComponent,
    DashboardOtrOpsReadinessComponent,
    DashboardSelfImprovingAIComponent,
    DashboardNumberComponent,
    ChangeComponent,
    DashboardEmptyStateComponent,
    DashboardInfoV2Component,
    DeltaComponent,
    EnginePreviewComponent,
    EngineJobComponent,
    AttentionItemsSummaryComponent,
    PipelineComponent,
    ActivityComponent,
    EventSummaryComponent,
    ErrorIconComponent,
    LogisticsComponent,
    RevenueComponent,
    TransactionsActivityComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    FreyaCommonModule,
    SharedModule,
    OverviewChipComponent,
    MarkdownModule.forChild(),
    TableModule,
    ButtonModule,
    TooltipModule,
    TagModule,
    InputNumberModule,
    InputTextModule,
  ],
  exports: [
    Dashboardv2Component,
  ],
})
export class DashboardModule { }
